/**
 * Current time in milliseconds as integer.
 *
 * Exists so that timestamps conform to our RxDb schema, which expects integers.
 */
export default function nowTimestamp(): number {
  // eslint-disable-next-line no-restricted-syntax
  return Math.round(Date.now());
}
